var baseStyles = {
raw: "*{-webkit-box-sizing:border-box;box-sizing:border-box}[class^=hcr-]{margin:0;padding:0}[class^=hcr-]:after,[class^=hcr-]:before{-webkit-box-sizing:border-box;box-sizing:border-box}",
map:{}};

export default baseStyles;
